export default __webpack_public_path__ + "static/media/package.1b5cb527.png";